import React from "react";

const AboutPage = () => {
  return (
    <div>
      <h1>CeSI</h1>
      <p>Cesi provides a web interface that manages many supervisors.</p>
      <p>We use these technologies:</p>
      <ul>
        <li>Python3 (+3.4)</li>
        <li>Flask (+1.0)</li>
        <li>ReactJs (+16.0)</li>
      </ul>
      <a href="https://github.com/gamegos/cesi">
        Source Code and Documentation
      </a>
    </div>
  );
};

export default AboutPage;
